/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetLookbookGalleryQueryVariables = Types.Exact<{
  [key: string]: never;
}>;
export type GetLookbookGalleryQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    businessLine: Types.BusinessLine;
    photoFullBody?: {
      __typename?: "ClientPhoto";
      id: string;
    } | null;
    referrals: {
      __typename?: "Referrals";
      incentive?: {
        __typename?: "ReferralIncentive";
        recipientCredit?: {
          __typename?: "Money";
          value: number;
          currency: Types.Currency;
        } | null;
      } | null;
    };
    vision: {
      __typename?: "Vision";
      id: string;
      onboardingStatus: Types.OnboardingStatus;
      isOptedInToRecurringLooks: boolean;
      notification?: {
        __typename?: "VisionNotification";
        productTrackingName?: string | null;
        productTrackingContentId: string;
        productTrackingActionName?: string | null;
        banner: {
          __typename?: "ModeBannerSlim";
          variant: Types.ModeBannerSlimVariant;
          message: string;
          icon?: Types.ModeIcon | null;
          id: string;
          cta?: {
            __typename?: "CallToAction";
            url: string;
            label: {
              __typename?: "I18nCopy";
              text: string;
            };
          } | null;
        };
      } | null;
      galleryQuickActionModule?: {
        __typename?: "VisionGalleryQuickActionModule";
        contentId: string;
        eyebrow?: string | null;
        title: string;
      } | null;
      currentLookBook?: {
        __typename?: "LookBook";
        id: string;
        looks: Array<{
          __typename?: "Look";
          id: string;
          resemblesMeAnswer?: boolean | null;
          stickerLabel?: {
            __typename?: "ModeStickerLabel";
            label: string;
            theme: Types.ModeStickerLabelTheme;
          } | null;
          image: {
            __typename?: "Image";
            baseUrl: string;
            mediaPath: string;
            altText: string;
          };
          shopProductVariants: Array<{
            __typename?: "ShopProductVariant";
            id: string;
            sku: string;
            url: string;
            purchased: boolean;
            image?: {
              __typename?: "ShopMedia";
              baseUrl: string;
              mediaPath: string;
              altText: string;
            } | null;
            shopProduct: {
              __typename?: "ShopProduct";
              name: string;
            };
            inventory: {
              __typename?: "ShopInventory";
              availability: Types.InventoryAvailability;
            };
          }>;
        }>;
      } | null;
    };
  } | null;
};
export const GetLookbookGalleryDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getLookbookGallery"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "client"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "businessLine"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "photoFullBody"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "referrals"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "incentive"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "recipientCredit"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "value"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "currency"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "vision"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "onboardingStatus"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "isOptedInToRecurringLooks"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "notification"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "banner"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "variant"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "message"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "icon"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "cta"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "label"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "text"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "url"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }]
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "productTrackingName"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "productTrackingContentId"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "productTrackingActionName"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "galleryQuickActionModule"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "contentId"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "eyebrow"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "title"
                    }
                  }]
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentLookBook"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "looks"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "stickerLabel"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "label"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "theme"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "resemblesMeAnswer"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "image"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "baseUrl"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "mediaPath"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "altText"
                            }
                          }]
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "shopProductVariants"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "id"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "sku"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "url"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "image"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "baseUrl"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "mediaPath"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "altText"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "shopProduct"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "name"
                                }
                              }]
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "purchased"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "inventory"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "availability"
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetLookbookGalleryQuery__
 *
 * To run a query within a React component, call `useGetLookbookGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookbookGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookbookGalleryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLookbookGalleryQuery(baseOptions?: Apollo.QueryHookOptions<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>(GetLookbookGalleryDocument, options);
}
export function useGetLookbookGalleryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>(GetLookbookGalleryDocument, options);
}
// @ts-ignore
export function useGetLookbookGallerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>): Apollo.UseSuspenseQueryResult<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>;
export function useGetLookbookGallerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>): Apollo.UseSuspenseQueryResult<GetLookbookGalleryQuery | undefined, GetLookbookGalleryQueryVariables>;
export function useGetLookbookGallerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>(GetLookbookGalleryDocument, options);
}
export type GetLookbookGalleryQueryHookResult = ReturnType<typeof useGetLookbookGalleryQuery>;
export type GetLookbookGalleryLazyQueryHookResult = ReturnType<typeof useGetLookbookGalleryLazyQuery>;
export type GetLookbookGallerySuspenseQueryHookResult = ReturnType<typeof useGetLookbookGallerySuspenseQuery>;
export type GetLookbookGalleryQueryResult = Apollo.QueryResult<GetLookbookGalleryQuery, GetLookbookGalleryQueryVariables>;